import {
  FormField,
  PasswordField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';

export const SecretAccessKeyAuth = ({
  keyIdFormKey,
  secretKeyFormKey,
  sessionTokenFormKey,
  disabled,
}: {
  keyIdFormKey: string;
  secretKeyFormKey: string;
  sessionTokenFormKey: string;
  disabled?: boolean;
}) => {
  const methods = useFormContext();
  const {
    register,
    formState: { dirtyFields, errors },
  } = methods;

  return (
    <>
      <FormField
        title="Access key ID"
        errorMessage={errors[keyIdFormKey]?.message as string}
      >
        <PasswordField
          {...register(keyIdFormKey, {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields[keyIdFormKey]}
          clearFormValue={() => methods.setValue(keyIdFormKey, '')}
          placeholder="e.g. AGDE221W4772DDQJUP4D9C"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Secret access key"
        errorMessage={errors[secretKeyFormKey]?.message as string}
      >
        <PasswordField
          {...register(secretKeyFormKey, {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields[secretKeyFormKey]}
          clearFormValue={() => methods.setValue(secretKeyFormKey, '')}
          placeholder="Secret access key"
          disabled={disabled}
          size="large"
        />
      </FormField>

      <FormField
        title="Session token"
        errorMessage={errors[sessionTokenFormKey]?.message as string}
        optional
      >
        <PasswordField
          {...register(sessionTokenFormKey)}
          isFormValueDirty={dirtyFields[sessionTokenFormKey]}
          clearFormValue={() => methods.setValue(sessionTokenFormKey, '')}
          placeholder="Session token (optional)"
          disabled={disabled}
          size="large"
        />
      </FormField>
    </>
  );
};

export const RoleArnAuth = ({
  roleArnFormKey,
  externalIdFormKey,
  disabled,
}: {
  roleArnFormKey: string;
  externalIdFormKey: string;
  disabled?: boolean;
}) => {
  const methods = useFormContext();
  const {
    register,
    formState: { dirtyFields, errors },
  } = methods;

  return (
    <>
      <FormField
        title="AWS role ARN"
        errorMessage={errors[roleArnFormKey]?.message as string}
      >
        <TextField
          {...register(roleArnFormKey, {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. arn:aws:iam::123456789012:role/my-role"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="External ID"
        optional
        errorMessage={errors[externalIdFormKey]?.message as string}
      >
        <PasswordField
          {...register(externalIdFormKey, {})}
          isFormValueDirty={dirtyFields[externalIdFormKey]}
          clearFormValue={() => methods.setValue(externalIdFormKey, '')}
          placeholder="External ID"
          disabled={disabled}
          size="large"
        />
      </FormField>
    </>
  );
};
